import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { makeStyles, Collapse, List } from '@material-ui/core'

import CustomDivider from './CustomDivider'
import { ITEM_SEPARATOR } from './CustomerSidebar.helpers'
import CustomListItemText from './CustomListItemText'
import ListItemButton from './ListItemButton'
import OffersConfiguratorButton from './OffersConfiguratorButton'
import PackageItem from './PackageItem'

import { Account } from '../../model/customer.model'

import Permission from '~/permissions/model/permissions.model'
import { selectHasPermission } from '~/permissions/store/permissions.selectors'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .account-sub-menu': {
      paddingBottom: theme.spacing(4),
    },
  },
  listItem: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(10),
  },
  listTriangleGapCompensor: {
    width: `calc(100% - ${theme.spacing(5)}px)`,
  },
}))

interface AccountItemProps {
  account: Account
  onChangeSelected: (itemId: string) => void
  selectedItemsIds: string[]
  itemId: string
}

const AccountItem: React.FC<AccountItemProps> = ({
  account,
  onChangeSelected,
  selectedItemsIds,
  itemId,
}) => {
  const classes = useStyles()
  const hasPermissionConfigureOffer = useSelector(selectHasPermission(Permission.CONFIGURE_OFFER))

  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(open || selectedItemsIds?.includes(itemId))
  }, [selectedItemsIds])

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <List
      disablePadding
      className={`${classes.root} ${classes.listTriangleGapCompensor}`}
      data-hook={`account-item-${account.accountNumber}`}
    >
      <ListItemButton
        className={classes.listItem}
        dropDown
        open={open}
        selected={false}
        onClick={() => handleClick()}
      >
        <CustomListItemText
          primary={`Contrato ${account.accountNumber}`}
          primaryTypographyProps={{ variant: 'subtitle2' }}
        />
      </ListItemButton>
      <CustomDivider />
      <Collapse in={open} timeout="auto" unmountOnExit className="account-sub-menu">
        <>
          {hasPermissionConfigureOffer && (
            <OffersConfiguratorButton
              accountNumber={account.accountNumber}
              onChangeSelected={onChangeSelected}
              selectedItemsIds={selectedItemsIds}
              itemId={`${itemId}/offers-configurator${ITEM_SEPARATOR}${account.accountNumber}`}
            />
          )}
          {account.packages?.map((packageData) => {
            return (
              <PackageItem
                key={packageData.subscriptions[0].identificationNr}
                packageData={packageData}
                onChangeSelected={onChangeSelected}
                selectedItemsIds={selectedItemsIds}
                itemId={`${itemId}`}
              />
            )
          })}
        </>
      </Collapse>
    </List>
  )
}

export default AccountItem
